var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17h1v-4h1l.024 3.482a.5.5 0 0 0 .5.5L8 17l2.874 1.916a.5.5 0 0 0 .277.084H17.5a.5.5 0 0 0 .5-.5V17h1v2h1l1.854-1.854a.5.5 0 0 0 .146-.353v-5.586a.5.5 0 0 0-.146-.353L20 9h-1v2h-1V9.268a.5.5 0 0 0-.223-.416l-2.651-1.768A.5.5 0 0 0 14.849 7H12.5V6H15V5H8v1h2.5v1H8.207a.5.5 0 0 0-.353.146L7 8H4.5a.5.5 0 0 0-.5.5V12H3V8H2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.7aafbcfbfcf9df81ec7d671e59d922fb.svg";
export { ForwardRef as ReactComponent };